<script setup lang="ts">
</script>

<template>
    <h1 class="size-full text-center col justify-center text-2xl font-bold text-blue">
        Nessuna sessione sperimentale prevista.
    </h1>
</template>

<style scoped>
</style>
